module.exports = MaterialUI.Typography;